export default __webpack_public_path__ + "static/media/be-date.3538c6f0.png";